var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.762,
    height: 40.689,
    viewBox: "0 0 37.762 40.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1062",
    "data-name": "Grupo 1062",
    transform: "translate(-2514.375 7050.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7294",
    "data-name": "Trazado 7294",
    d: "M2562.017-6996.183a3.118,3.118,0,0,1-3.118,3.117,3.117,3.117,0,0,1-3.117-3.117c0-1.723,3.117-4.681,3.117-4.681S2562.017-6997.905,2562.017-6996.183Z",
    transform: "translate(-14.872 -17.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_310",
    "data-name": "L\\xEDnea 310",
    x2: 5.806,
    transform: "translate(2529.297 -7042.257)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_311",
    "data-name": "L\\xEDnea 311",
    x1: 3.842,
    transform: "translate(2529.297 -7033.815)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7295",
    "data-name": "Trazado 7295",
    d: "M2544.971-7037.877h0a14.238,14.238,0,0,1,14.2,14.2",
    transform: "translate(-10.893 -4.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7296",
    "data-name": "Trazado 7296",
    d: "M2544.971-7024.4h0a5.7,5.7,0,0,1,5.679,5.679",
    transform: "translate(-10.893 -9.329)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7297",
    "data-name": "Trazado 7297",
    d: "M2529.571-7037.877h0a14.238,14.238,0,0,0-14.2,14.2",
    transform: "translate(0 -4.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7298",
    "data-name": "Trazado 7298",
    d: "M2534.532-7024.4h0a5.7,5.7,0,0,0-5.678,5.679",
    transform: "translate(-4.961 -9.329)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_312",
    "data-name": "L\\xEDnea 312",
    y2: 13.659,
    transform: "translate(2515.375 -7027.205)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_313",
    "data-name": "L\\xEDnea 313",
    y2: 13.659,
    transform: "translate(2523.893 -7027.205)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_966",
    "data-name": "Rect\\xE1ngulo 966",
    width: 14.22,
    height: 3.157,
    transform: "translate(2536.917 -7028.05)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_314",
    "data-name": "L\\xEDnea 314",
    y2: 8.443,
    transform: "translate(2529.297 -7042.257)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_315",
    "data-name": "L\\xEDnea 315",
    y2: 8.443,
    transform: "translate(2535.103 -7042.257)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_316",
    "data-name": "L\\xEDnea 316",
    y2: 6.176,
    transform: "translate(2532.482 -7048.434)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_317",
    "data-name": "L\\xEDnea 317",
    x2: 13.024,
    transform: "translate(2525.156 -7049.747)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrip);
export default __webpack_public_path__ + "static/media/drip.d2638fc6.svg";
export { ForwardRef as ReactComponent };